import { TextInput } from '@dreryk/react-components';

import { magistralDrugTranslationKeys } from '../../../../../translations';
import { MagistralDrugCreateFormController } from '../../../magistralDrug/create/MagistralDrugCreateForm.types';

type DrugFormTextInputProps = Pick<MagistralDrugCreateFormController, 'register'>;

export const DrugFormTextInput = (props: DrugFormTextInputProps): JSX.Element => {
   return (
      <TextInput
         label={magistralDrugTranslationKeys.drugForm}
         testId={'drugForm'}
         controller={props.register('drugForm', { required: true, maxLength: 200 })}
      />
   );
};
